export default __webpack_public_path__ + "static/media/J240_CoC.dc97d2d1.pdf";